import { useRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function C_E_NUMBER({
  tempValue,
  onChange,
  onBlur,
  onKeyDown,
  inPopup = false,
}) {
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  const properties_state = useSelector((state) => state.properties);

  // Auto-focus the input the exact moment it mounts (Table mode only)
  useEffect(() => {
    if (!inPopup && inputRef.current) {
      inputRef.current.focus();
    }
  }, [inPopup]);

  // Intercept the typing to forcefully strip out text/symbols
  const handleLocalChange = (e) => {
    let val = e.target.value;

    // 1. Strip everything EXCEPT digits (0-9) and the decimal point (.)
    val = val.replace(/[^0-9.]/g, "");

    // 2. Prevent multiple decimal points (e.g., changes "1.2.3" to "1.23")
    const parts = val.split(".");
    if (parts.length > 2) {
      val = parts[0] + "." + parts.slice(1).join("");
    }

    // 3. Update the event value and pass it back to parent
    e.target.value = val;
    onChange(e);
  };

  // --- NEW: Indonesian Formatting Logic ---
  const formatDisplayValue = (val) => {
    if (val === null || val === undefined || val === "") return "";
    const parts = val.toString().split(".");
    // Format thousands with dots
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    // Connect decimals with comma
    return parts.join(",");
  };

  // 1. POPUP MODE
  if (inPopup) {
    // THE MAGIC: Show raw value when typing, formatted value when just viewing
    const displayValue = isFocused ? tempValue : formatDisplayValue(tempValue);
    const mode_map = properties_state.mode_map; //editor || viewer
    return (
      <div>
        <input
          disabled={mode_map === "viewer"}
          ref={inputRef}
          type="text"
          inputMode="decimal"
          value={displayValue}
          onChange={handleLocalChange}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur(e);
          }}
          onKeyDown={onKeyDown}
          onFocus={() => setIsFocused(true)}
        />
        {isFocused && (
          <p className="text_small sub_color margin_top_small">
            Press Enter to save
          </p>
        )}
      </div>
    );
  }

  return (
    <input
      ref={inputRef}
      type="text"
      inputMode="decimal"
      value={tempValue}
      onChange={handleLocalChange}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      className="input_table"
      style={{ textAlign: "right" }}
    />
  );
}
